import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '../context/ThemeContext'
import { Button } from '../components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card'
import { ArrowLeft, Mail, Globe, MessageCircle } from 'lucide-react'
import DarkModeToggle from '../components/DarkModeToggle'

export default function ContactUs() {
  const navigate = useNavigate()
  const { isDarkMode } = useTheme()

  return (
    <div className={`min-h-screen ${isDarkMode ? 'bg-gray-900' : 'bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50'} py-12 px-4`}>
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <Button onClick={() => navigate('/home')} variant="ghost">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
          <DarkModeToggle />
        </div>

        <Card className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white/90 border-purple-100'} backdrop-blur-sm`}>
          <CardHeader>
            <CardTitle className={`text-4xl font-bold text-center ${isDarkMode ? 'text-gray-100' : ''}`} style={{fontFamily: 'Space Grotesk, sans-serif'}}>
              <MessageCircle className="w-12 h-12 mx-auto mb-4 text-indigo-600" />
              Contact Us
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-8">
            <p className={`text-center text-lg ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              Have questions or need support? We're here to help!
            </p>

            <div className="space-y-6">
              {/* Email */}
              <div className={`p-6 rounded-xl ${isDarkMode ? 'bg-gray-700' : 'bg-gradient-to-r from-indigo-50 to-purple-50'}`}>
                <div className="flex items-center gap-4 mb-3">
                  <div className="w-12 h-12 rounded-full bg-indigo-600 flex items-center justify-center">
                    <Mail className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className={`text-xl font-bold ${isDarkMode ? 'text-gray-100' : 'text-gray-800'}`}>Email Us</h3>
                    <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Send us an email anytime</p>
                  </div>
                </div>
                <a 
                  href="mailto:info@publicrespect.com"
                  className="text-lg font-semibold text-indigo-600 hover:text-indigo-700 transition-colors"
                >
                  info@publicrespect.com
                </a>
              </div>

              {/* Website */}
              <div className={`p-6 rounded-xl ${isDarkMode ? 'bg-gray-700' : 'bg-gradient-to-r from-purple-50 to-pink-50'}`}>
                <div className="flex items-center gap-4 mb-3">
                  <div className="w-12 h-12 rounded-full bg-purple-600 flex items-center justify-center">
                    <Globe className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className={`text-xl font-bold ${isDarkMode ? 'text-gray-100' : 'text-gray-800'}`}>Visit Our Website</h3>
                    <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Learn more about Public Respect</p>
                  </div>
                </div>
                <a 
                  href="https://publicrespect.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-lg font-semibold text-purple-600 hover:text-purple-700 transition-colors"
                >
                  https://publicrespect.com/
                </a>
              </div>
            </div>

            <div className={`p-4 rounded-lg ${isDarkMode ? 'bg-blue-900/30 border border-blue-700' : 'bg-blue-50 border border-blue-200'}`}>
              <p className={`text-sm text-center ${isDarkMode ? 'text-blue-200' : 'text-blue-800'}`}>
                <strong>Response Time:</strong> We typically respond within 24-48 hours during business days.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
